export default __webpack_public_path__ + "static/media/plain-sticker-g.a13e3df7.png";